// * error form
export const requiredFieldMessage = 'This field is required';
export const requiredSetMessage = 'This set is required';
export const invalidEmailMessage = 'This email format is invalid';
export const exactLimitMessage = (limit: number) => 'This field has exactly ' + limit + ' symbols';

export const passwordLengthMessage = (min: number) => 'The password must be at least ' + min + ' characters long';
export const oneCapitalCharRequiredMessage = 'At least one uppercase character  required';
export const atLeastOneNumberRequiredMessage = 'At least on number char required';

export const incorrectOrgIdMessage = 'Incorrect organization id';
export const existCampaignErrorMessage = 'This campaign name already exists';
export const onlySimpleCharactersAllowedMessage = 'Allowed only 0-9 a-z A-Z';
export const incorrectIdMessage = 'Allowed only 0-9 a-z A-Z and minimum 4 length';
export const incorrectDateMessage = 'Invalid date';
export const incorrectMonthMessage = 'Invalid month';
export const incorrectNumberMessage = 'The value must be numbers';
export const incorrectDateFieldCountMessage = 'Invalid date, example YYYY';
export const incorrectMonthFieldCountMessage = 'Invalid month, example MM';

// export const passwordPatternMessage = 'The password must contain a digit and an uppercase character';
// export const repeatPasswordMessage = 'Please, repeat your password';
// export const matchPasswordsMessage = 'Passwords are not identical';
// export const tagInvalidMessage = "A hashtag cannot have any '#' or whitespaces within the content.";

// * error auth
export const errorDataMessage = 'Your data is incorrect';
export const notEntryAllowedMessage = 'You have no rights to enter';
export const wrongInviteCodeMessage = 'Wrong invite code';

// * global
export const noContentMessage = '...';
export const noDataAvailableMessage = 'No available data for this filters';
export const asyncErrorMessage = 'Something went wrong!';
